import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentCustomForm {
    export const ID = 'customform';

    export interface IData extends NICmsContentComponent.IData {
        form_identifier?: string;
        newsletter_source?: string;
    }
}
